import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceBaseService } from '../core/service-base.service';
import { GenericDataService } from '../shared/generic-data.service';

interface  LotPartial {
  id;
  labresultSecretCode?: string;
  labresultPublicCode?: string;
}

/**
 * Lot connect
 *
 * Works on the lot resource, but only on its labresultPublicCode field.
 *
 * The backend endpoint works like this:
 *
 * - update sets the labresultPublicCode field by passing labresultSecretCode.
 * - delete unsets labresultPublicCode field (lot is not actually deleted).
 *
 */
@Injectable({
  providedIn: 'root'
})
export class LotConnectService extends GenericDataService<LotPartial> {
  endpointName = '/lotconnect';

  // updateItem(id: string, data: T) {
  //   return this.http
  //     .put<T>(
  //       this.serviceBase.getServiceBase() + this.endpointName + '/' + id,
  //       data,
  //       this.serviceBase.getHeaders()
  //     )
  //     .pipe(take(1));
  // }

  constructor(http: HttpClient, serviceBase: ServiceBaseService) {
    super(http, serviceBase);
  }
}
